import React from "react";
import { BoxProps } from "rebass";
import Button, { Props as ButtonProps } from "./Button";

interface Props extends ButtonProps {
  reverse?: boolean;
  icon: React.ReactElement;
}

const ButtonIcon: React.FunctionComponent<Props & BoxProps> = ({
  reverse = false,
  icon,
  children,
  ...restProps
}) => {
  const iconStyles = {
    ml: reverse ? -1 : 2,
    mr: reverse ? 2 : -1,
  };

  const styledIcon = React.cloneElement(icon, {
    sx: { ...iconStyles, ...icon.props.sx },
    size: "20px",
  });

  return (
    <Button {...restProps}>
      {reverse && styledIcon}
      {children}
      {!reverse && styledIcon}
    </Button>
  );
};

export default ButtonIcon;
